/** Client-side fallbacks when lookup API is unavailable (must match backend seed). */
export const LOOKUP_FALLBACKS = {
  paddy_variety: [
    { value: "1509", label: "1509" },
    { value: "1121", label: "1121" },
    { value: "1401", label: "1401" },
    { value: "PUSA", label: "PUSA" },
    { value: "SHARBATI", label: "SHARBATI" },
  ],
  payment_condition: [
    { value: "SAME_DAY", label: "Same day" },
    { value: "TWO_DAYS_AFTER_LOADING_UNLOADING", label: "2 days after loading/unloading" },
    { value: "FOUR_TO_FIVE_DAYS", label: "4–5 days" },
    { value: "EIGHT_TO_TEN_DAYS", label: "8–10 days" },
    { value: "FORTY_DAYS", label: "40 days" },
    { value: "OTHER", label: "Other" },
  ],
  bardana: [
    { value: "BAG_5KG", label: "5 kg" },
    { value: "BAG_10KG", label: "10 kg" },
    { value: "BAG_20KG", label: "20 kg" },
    { value: "BAG_25KG", label: "25 kg" },
    { value: "BAG_30KG", label: "30 kg" },
    { value: "JUTE_BAG_40KG", label: "40 kg jute" },
    { value: "BAG_40KG", label: "40 kg PP" },
    { value: "BAG_50KG", label: "50 kg" },
    { value: "JUTE_BAG_60KG", label: "60 kg jute" },
    { value: "BAG_60KG", label: "60 kg PP" },
    { value: "PP", label: "PP" },
    { value: "LOOSE", label: "Loose" },
  ],
  bardana_deduction: [
    { value: "GM_500_PER_QTL", label: "500gm per qtl" },
    { value: "GM_300_PER_QTL", label: "300gm per qtl" },
    { value: "KG_1_PER_QTL", label: "1kg per qtl" },
  ],
  delivery_condition: [
    { value: "TRUCK_LOAD", label: "Truck Load" },
    { value: "FOR", label: "FOR" },
  ],
  rice_packing: [
    { value: "PP_PACKING", label: "PP packing" },
    { value: "JUTE_BAG", label: "Jute bag" },
    { value: "BUYER_PACKING", label: "Buyer packing" },
    { value: "PP_50KG", label: "PP packing (50 kg)" },
  ],
  sales_cd_percent: [
    { value: "1", label: "1%" },
    { value: "1.5", label: "1.5%" },
  ],
  rice_quality_type: [
    { value: "STEAMED", label: "Steamed" },
    { value: "WHITE_SELLA", label: "White Sella" },
    { value: "GOLDEN_SELLA", label: "Golden Sella" },
  ],
  rice_grade: [
    { value: "WAND", label: "Wand" },
    { value: "TIBAR", label: "Tibar" },
    { value: "DUBAR", label: "Dubar" },
    { value: "MINI_DUBAR", label: "Mini Dubar" },
    { value: "SUPER_DUBAR", label: "Super Dubar" },
    { value: "MOGRA", label: "Mogra" },
    { value: "SUPER_MOGRA", label: "Super Mogra" },
    { value: "MINI_MOGRA", label: "Mini Mogra" },
    { value: "REJECTION_WAND", label: "Rejection Wand" },
    { value: "SIZER_WAND", label: "Sizer Wand" },
    { value: "REJECTION_BROKEN", label: "Rejection Broken" },
    { value: "SIZER_BROKEN", label: "Sizer Broken" },
  ],
  brokerage_basis: [
    { value: "GROSS_PCT", label: "% of gross" },
    { value: "PER_QTL", label: "Per qtl" },
  ],
  sales_delivery_condition: [
    { value: "TRUCK_LOAD", label: "Truck Load" },
    { value: "FOR", label: "FOR" },
    { value: "EX_MILL", label: "Ex-mill" },
    { value: "OTHER", label: "Other" },
  ],
  cd_percent: [
    { value: "1", label: "1%" },
    { value: "2", label: "2%" },
  ],
};

export function optionsForGroup(lookupMap, groupKey, { activeOnly = true } = {}) {
  const rows = lookupMap?.[groupKey];
  if (rows?.length) {
    return rows
      .filter((r) => !activeOnly || r.is_active !== false)
      .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0))
      .map((r) => ({ value: r.value, label: r.label || r.value }));
  }
  return LOOKUP_FALLBACKS[groupKey] || [];
}

export function labelForOptions(options, value) {
  return options.find((o) => o.value === value)?.label ?? value ?? "—";
}

export function groupedResponseToMap(data) {
  const map = {};
  for (const g of data?.groups || []) {
    map[g.key] = g.options || [];
  }
  return map;
}
